import React, {Component} from 'react';
import { Badge, Modal, ModalHeader, ModalBody } from 'reactstrap';

class ModalButton extends Component{
    constructor(props) {
        super(props)
        this.state = {
          modal: false
        }
      }
    
      toggle = () => {
        this.setState({modal: !this.state.modal})
      }

      cancel = () => {
        if(this.props.cancel)
          return this.props.cancel(this.toggle)
        
        this.toggle()
      }

      getText = () => {
        return this.props.text.split(',').map(line => (
          <div>
            {line}
            <br/>
          </div>
        ))
      }
    
      render() {
        return (
          <div>
            <Badge className="status-badge btn" color="danger" onClick={this.toggle}>Erro</Badge>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className="modal-danger modal-lg">
              <ModalHeader toggle={this.toggle}>Erros</ModalHeader>
              <ModalBody>
                <p>{this.getText()}</p>
              </ModalBody>
            </Modal>
          </div>
        );
      }
}

export default ModalButton;


// WEBPACK FOOTER //
// ./src/views/components/status-badge/ErrorStatusBadge.js